import Input from '@/components/form/Input';
import DatePicker from '@/components/form/DatePicker';

const InformationFields = () => {
  return (
    <div className="mb-8 space-y-1">
      <h3>Information</h3>
      <div className="mb-1">
        <Input name="phone" label="Phone" type="tel" autoComplete="tel" />
      </div>
      <DatePicker name="birthDate" label="Birth Date" />
    </div>
  );
};

export default InformationFields;
